import { render, staticRenderFns } from "./MpConfig.vue?vue&type=template&id=73dfd990&"
import script from "./MpConfig.vue?vue&type=script&lang=js&"
export * from "./MpConfig.vue?vue&type=script&lang=js&"
import style0 from "./MpConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports